import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'CTAButton',
  props: ['disabled'],
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(_component_b_button, {
    class: "d-flex align-items-center justify-content-between",
    size: "lg",
    disabled: _ctx.$props.disabled
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "header"),
      _renderSlot(_ctx.$slots, "image")
    ]),
    _: 3
  }, 8, ["disabled"]))
}
}

})